import { Exclude } from "class-transformer";
import {
  Column,
  Entity,
  Index,
  JoinColumn,
  ManyToOne,
  OneToMany,
  PrimaryGeneratedColumn,
} from "typeorm";
import { AreaTreeNodes } from "./area-tree-nodes.entity";
import { Clients } from "./clients.entity";
import { CxBrand } from "./cx-brand.entity";
import { CxShopToken } from "./cx-shop-token.entity";
import { Services } from "./services.entity";
import { Prefecture } from "./prefecture.entity";

@Index("index_branches_on_area_tree_node_id", ["areaTreeNodeId"], {})
@Index("index_branches_on_client_id", ["clientId"], {})
@Index(
  "index_branches_on_service_id_and_data_link_uri",
  ["dataLinkUri", "serviceId"],
  { unique: true }
)
@Index("branches_pkey", ["id"], { unique: true })
@Index("index_branches_on_name", ["name"], {})
@Index("index_branches_on_service_id", ["serviceId"], {})
@Entity("branches", { schema: "public", synchronize: false, })
export class Branches {
  @PrimaryGeneratedColumn({ type: "integer", name: "id" })
  id: number;

  @Column("integer", { name: "client_id" })
  clientId: number;

  @Column("character varying", { name: "encrypted_password" })
  encryptedPassword: string;

  @Column("character varying", { name: "name" })
  name: string;

  @Column("character varying", { name: "name_kana", nullable: true })
  nameKana: string | null;

  @Column("timestamp without time zone", { name: "created_at" })
  createdAt: Date;

  @Column("timestamp without time zone", { name: "updated_at" })
  updatedAt: Date;

  @Column("integer", { name: "area_tree_node_id", nullable: true })
  areaTreeNodeId: number | null;

  @Column("character varying", { name: "data_link_uri", nullable: true })
  dataLinkUri: string | null;

  @Column("integer", { name: "service_id", nullable: true })
  serviceId: number | null;

  @Column("character varying", {
    name: "name_initial",
    nullable: true,
    length: 1,
  })
  nameInitial: string | null;

  @Column("character varying", { name: "external_link", nullable: true })
  externalLink: string | null;

  @Column("character varying", { name: "created_by", nullable: true })
  createdBy: string | null;

  @Column("character varying", { name: "updated_by", nullable: true })
  updatedBy: string | null;

  @ManyToOne(() => AreaTreeNodes, (areaTreeNodes) => areaTreeNodes.branches)
  @JoinColumn([{ name: "area_tree_node_id", referencedColumnName: "id" }])
  areaTreeNode: AreaTreeNodes;

  @ManyToOne(() => Clients, (clients) => clients.branches)
  @JoinColumn([{ name: "client_id", referencedColumnName: "id" }])
  client: Clients;

  // ======================================================
  // CXサーベイ用に追加
  // ======================================================
  @Column({ name: 'short_name', length: 5, })
  shortName: string;

  @Exclude()
  @Column({ length: 512, })
  email: string;

  @Exclude()
  @Column({ name: 'email_cc', length: 2000, default: '', })
  emailCc: string;

  @Exclude()
  @Column({ name: 'email_bcc', length: 2000, default: '', })
  emailBcc: string;

  @Exclude()
  @Column('character varying', { name: 'prefecture_code' })
  prefectureCode?: string;

  @ManyToOne(() => CxBrand, cxBrand => cxBrand.branches, { nullable: true, })
  @JoinColumn({ name: 'cx_brand_id', referencedColumnName: 'id', })
  cxBrand: CxBrand;

  @ManyToOne(() => Services, (service) => service.branches)
  @JoinColumn({ name: 'service_id', referencedColumnName: 'id', })
  service?: Services;

  @OneToMany(() => CxShopToken, cxShopToken => cxShopToken.branch)
  cxShopTokens: CxShopToken[];

  @ManyToOne(() => Prefecture, (prefecture) => prefecture.branches)
  @JoinColumn({ name: 'prefecture_code', referencedColumnName: 'code' })
  prefecture?: Prefecture;
}

